import Person from './Person';
import { observable } from 'mobx';
import { persist } from 'mobx-persist';

export default class User extends Person {
  @persist
  @observable
  admin;
  constructor({ archived, admin, type, experience, ...props } = {}) {
    super({ ...props });
    this.archived = archived;
    this.admin = admin;
    this.experience = experience;
    this.type = type;
  }
}



// WEBPACK FOOTER //
// ./src/models/User.js